// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutPlaceOrder_container__39sLl","button":"CheckoutPlaceOrder_button__2XFx8","disabled":"CheckoutPlaceOrder_disabled__2u396"};